<form [formGroup]="invitationForm">
  <h3 nz-typography class="nfl-form-label">Partners & Invitations</h3>

  <div>
    <div class="email-selection">
      <nz-input-group>
        <div class="tag-input-wrapper">
          <nz-tag
            *ngFor="let email of partnerEmails; let i = index"
            [nzColor]="i === 0 ? 'blue' : 'default'"
            [nzMode]="i === 0 ? 'closeable' : 'default'"
            nzShape="round"
            (nzOnClose)="onRemoveEmail(i)"
          >
            {{ email }}
          </nz-tag>

          <nz-form-control [nzErrorTip]="emailErrorTpl">
            <input
              nz-input
              *ngIf="partnerEmails.length < 1"
              nzSize="large"
              placeholder="Enter partner email address"
              formControlName="partnerEmail"
            />
            <ng-template #emailErrorTpl let-control>
              <ng-container *ngIf="control.hasError('required')"> Email is required </ng-container>
              <ng-container *ngIf="control.hasError('pattern')"> Please enter a valid email address </ng-container>
            </ng-template>
          </nz-form-control>
        </div>
      </nz-input-group>
      <button
        nz-button
        nzType="primary"
        nzSize="large"
        [disabled]="!invitationForm.get('partnerEmail')?.valid || isValidating"
        (click)="onValidateEmail()"
        [nzLoading]="isValidating"
      >
        Validate
      </button>
    </div>
    <div class="alert-section" *ngIf="collaborationDataService.errorMessage">
      <nz-alert nzType="warning" [nzMessage]="collaborationDataService.errorMessage" nzShowIcon></nz-alert>
    </div>
  </div>

  <div class="message-section">
    <h4 nz-typography class="nfl-form-label">Message</h4>
    <nz-form-item>
      <nz-form-control>
        <textarea
          nz-input
          rows="6"
          placeholder="Enter Invite Message"
          formControlName="partnerInviteMessage"
          maxlength="500"
        ></textarea>
      </nz-form-control>
    </nz-form-item>
  </div>
</form>
